// extracted by mini-css-extract-plugin
export default {"title":"LayoutSetting_title__lhazA"};